import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {Comment} from '@angular/compiler';
import {Postcard} from './postcard';
import {Observable} from 'rxjs-compat';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';


@Injectable()
export class ApiService {

  // public urlBase = 'http://localhost:8888/postcards/postcards-api/public';
  public urlBase = 'https://www.lancaster.ac.uk/fass/projects/edwardian-postcards/postcards-api/public';

  constructor(private client: HttpClient) {
  }

  getUserInfo(token: string): Observable<Comment[]> {
    return this.client.post('https://edwardian-postcard.eu.auth0.com/userinfo/', {
      headers: new Headers({
        'Authorization': 'Bearer ' + token
      })
    })
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public getUserByToken(token): Observable<Comment[]> {
    return this.client.post('https://edwardian-postcard.eu.auth0.com/tokeninfo', {
      'id_token': token
    })
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public getPostcard(id): Observable<Postcard> {
    return this.client.get(this.urlBase + '/getPostcardDataById/' + id)
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public getYears(): Observable<Comment[]> {
    return this.client.get(this.urlBase + '/getAllYears')
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  // public getAllGroups(): Observable<Comment[]> {
  //   return this.client.get(this.urlBase + '/getAllGroups')
  //     .pipe(
  //       map((res: Response) => res.json()),
  //       catchError((error, caught) => this.handleError(error))
  //     );
  // }

  // public getSurnames(): Observable<Comment[]> {
  //   return this.client.get(this.urlBase + '/getAllSurnames')
  //     .pipe(
  //       map(res => res),
  //       catchError((error) => this.handleError(error))
  //     );
  // }

  // public getTowns(town): Observable<Comment[]> {
  //   return this.client.post(this.urlBase + '/getAllTowns', {
  //     'town': town
  //   })
  //     .pipe(
  //       map((res: Response) => res.json()),
  //       catchError((error) => this.handleError(error))
  //     );
  // }

  // public getPostedFrom(): Observable<Comment[]> {
  //   return this.client.get(this.urlBase + '/getAllPostedFrom')
  //     .pipe(
  //       map(res => res),
  //       catchError((error) => this.handleError(error))
  //     );
  // }

  public getPostcards(surname, town, from, year): Observable<Postcard []> {
    return this.client.post(this.urlBase + '/getPostcardsBySearch', {
      'surname': surname,
      'town': town,
      'from': from,
      'year': year
    })
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public getUserData(name, email, picture): Observable<JSON> {
    return this.client.post(this.urlBase + '/addUser', {
      'name': name,
      'email': email,
      'picture': picture
    })
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public addTranscript(postcard, id): Observable<Comment []> {
    return this.client.post(this.urlBase + '/addTranscript', {
      'postcard': postcard,
      'id': id
    })
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public getAllUntranscribedPostcards(): Observable<Comment[]> {
    return this.client.get(this.urlBase + '/getAllUntranscribedPostcards')
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public countAllUntranscribedPostcards(): Observable<Comment[]> {
    return this.client.get(this.urlBase + '/countAllUntranscribedPostcards')
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public getUserActions(id): Observable<Comment []> {
    return this.client.post(this.urlBase + '/getUserActions', {
      'id': id
    })
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public getStats(id): Observable<Comment []> {
    return this.client.post(this.urlBase + '/getStats', {
      'id': id
    })
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public reportPostcard(postcard_id, transcript_id, user_id, action): Observable<Array<Object []>> {
    return this.client.post(this.urlBase + '/reportPostcard', {
      'postcard_id': postcard_id,
      'transcript_id': transcript_id,
      'user_id': user_id,
      'action': action
    })
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public getUsers(): Observable<Comment []> {
    return this.client.get(this.urlBase + '/getUsers')
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public getFlaggedPostcards(): Observable<Comment []> {
    return this.client.get(this.urlBase + '/getFlaggedPostcards')
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public getUserMetrics(id): Observable<Comment []> {
    return this.client.post(this.urlBase + '/getUserMetrics', {
      'id': id
    })
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  public updateUserRole(id, role): Observable<Comment []> {
    return this.client.post(this.urlBase + '/updateUserRole', {
      'id': id,
      'role': role
    })
      .pipe(
        map(res => res),
        catchError((error) => this.handleError(error))
      );
  }

  // Handle errors
  private handleError(err): ErrorObservable<any> {
    const errorMsg = err.message || 'Error: Unable to complete request.';
    if (err.message && err.message.indexOf('No JWT present') > -1) {
      // this.auth.login();
      console.log('No login present...');
    }
    return ErrorObservable.create(errorMsg);
  }
}
